import { Guest } from 'shared-types/Basket';
import { useTranslations } from '@lang';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { GuestDetails } from '../../components/GuestForm/GuestDetails';
import { MappedGuest } from '../../types';
import { NotesField } from '../../components/NotesField';
import { usePackageConfiguration } from '../../contexts';
import { FormStepSectionWrapper, NotesWrapper, PageTitle } from '../FormSteps.styles';
import { useStepFooter } from '../hooks/useStepFooter';
import { useGuestDetailsUpdate } from '../hooks/useGuestDetailsUpdate';
import { GuestDetailsWrapper, TitleWrapper } from './GuestDetailsStep.styles';
import { mapLoggedInUserToGuest } from '../../helpers/mapLoggedInUserToGuest';
import { validateGuestDetails } from '../../helpers/validateGuestDetails';
import { useAddExistingGuest } from '../hooks/useAddExistingGuest';
import { AddExistingGuests } from '../../components/AddExistingGuests';

export const GuestDetailsStep = () => {
  const { t } = useTranslations();

  const { journeyParams, basketGuests, loggedInGuest } = usePackageConfiguration();

  const mappedloggedInGuestData = mapLoggedInUserToGuest(loggedInGuest);
  const [availableGuests, setAvailableGuests] = useState<MappedGuest[]>(
    mappedloggedInGuestData ? [mappedloggedInGuestData] : []
  );

  const { handleGuestPillClick, selectedGuests, existingGuests } = useAddExistingGuest({
    availableGuests,
    basketGuests,
  });

  const { watch } = useFormContext();
  const guests = watch('guests') || [];
  const isValid = validateGuestDetails(guests);

  const updateAvailableGuestsOnSubmit = useGuestDetailsUpdate(availableGuests, setAvailableGuests);

  const { adults, children } = journeyParams;

  const footer = useStepFooter({ isValid, onButtonClick: updateAvailableGuestsOnSubmit });

  return (
    <GuestDetailsWrapper>
      <TitleWrapper>
        <PageTitle noBorder>{t('common.guests')}</PageTitle>
      </TitleWrapper>

      <FormStepSectionWrapper isLoggedIn={true}>
        {/* hardcoded for now until we get designs for the signin modal */}
        <AddExistingGuests
          selectedGuests={selectedGuests}
          existingGuests={existingGuests as Guest[]}
          isGenderSpecific={false}
          guest={loggedInGuest as MappedGuest}
          handleGuestPillClick={handleGuestPillClick}
        />
        {Array.from({ length: adults }, (_, guestIndex) => (
          <GuestDetails
            key={`guest-${guestIndex}`}
            isGenderSpecific={false}
            guestIndex={guestIndex}
            isDisabled={false}
            withGenderSelect={false}
          />
        ))}
        {children ? <>+{t('basket.children', { children })}</> : null}
        <NotesWrapper>
          <NotesField name="roomNotes" label={t('rooms.notes')} />
        </NotesWrapper>
      </FormStepSectionWrapper>
      {footer}
    </GuestDetailsWrapper>
  );
};
